import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase config - these values are safe to expose in client-side code
// Security is enforced through Firestore Security Rules and Storage Rules
// See firestore.rules and storage.rules files
const devConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDT_owfP4VsHzeo6YqAf2jDSk-UpDJD7fc",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "connector-40c28.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "connector-40c28",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "connector-40c28.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1019204034291",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1019204034291:web:5a5a2fec1bc2c505dae186",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-YQZGRB4VSM"
};

const prodConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCKwIhjHzelDPHtgz4priIthiXLcTgwyLQ",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "nodecanvas-app.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "nodecanvas-app",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "nodecanvas-app.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "194630524884",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:194630524884:web:4734e1a21c7122eaf00041",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-8J6B8N2R8K"
};

const config = process.env.REACT_APP_ENV === "production" ? prodConfig : devConfig;

const app = initializeApp(config);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;